import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import InputsCreatorUniversal from "../../../../hooks/inputCreatorUniversal";
import { addAdditionalCustomValidation, optionsAppFooterRHF } from "./optionsAppFooterRHF";

import innerStyles from "./appFooterRHF.module.css";

export default function AppFooterRHF({
  styles,
  register,
  newData,
  control,
  setValue,
  mode,
  errors = {},
  clearErrors,
  fileName,
  handleFile,
  clearFile,
  getValues,
  viewFileName,
  fileDownloadApi,
  typeOfReceivedFile,
  needSheetCnt = true,
  isFileRequired,
  isFileRequiredError,
  appDateAdditionalCustomValidation,
}) {
  const [options, setOptions] = useState(optionsAppFooterRHF.inputsOptions);
  const usersLibrary = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.usersLibrary;
  });
  const userInfo = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.userInfo;
  });
  useEffect(() => {
    setOptions({ ...addAdditionalCustomValidation(appDateAdditionalCustomValidation) });
  }, [appDateAdditionalCustomValidation]);

  return (
    <div className={innerStyles["content-block"]}>
      {mode === "add" || mode === "edit" ? (
        <>
          {Object.values(options).map((item) => {
            switch (item.type) {
              case "file":
                return (
                  <div key={item.key}>
                    {newData.viewFileName && (
                      <div className={innerStyles["text-block-view-file"]}>
                        <p className={innerStyles["option-label-view"]}>Файл заявления</p>
                        <a
                          className={innerStyles["option-value-view"]}
                          href={`${fileDownloadApi}${newData.appFileId}`}
                          target="_blank">
                          {newData.viewFileName}
                        </a>
                      </div>
                    )}
                    <label className={innerStyles["input-file"]}>
                      <span className={innerStyles["input-file-btn"]}>
                        Выберите файл заявления
                        {mode !== "view" && isFileRequired && (
                          <span className={innerStyles["red-dot"]}>*</span>
                        )}
                      </span>

                      {!fileName && (
                        <input
                          type="file"
                          name="file"
                          accept={typeOfReceivedFile ? typeOfReceivedFile : ".doc,.docx,.pdf"}
                          onChange={(e) => handleFile(e)}
                        />
                      )}
                      <span
                        className={innerStyles["input-file-text"]}
                        type="text">
                        <span className={innerStyles["file-name"]}>{fileName || "Не выбрано"}</span>
                        <div className={innerStyles["icons-block"]}>
                          {fileName && (
                            <span
                              onClick={(e) => clearFile(e)}
                              className={innerStyles["delete-icon"]}></span>
                          )}
                          <span className={innerStyles["paperclip"]}></span>
                        </div>
                      </span>
                    </label>
                    {isFileRequiredError && (
                      <div className={innerStyles["error-text"]}>{isFileRequiredError}</div>
                    )}
                  </div>
                );
              default:
                if (item.key === "appUser") {
                  return (
                    <div
                      key={item.key}
                      className={innerStyles["text-block"]}>
                      <p className={innerStyles["option-label"]}>{item.label}</p>
                      <p className={innerStyles["option-value"]}>
                        {usersLibrary.find((elem) => elem.value === newData?.inspector)?.name ||
                          usersLibrary.find((elem) => elem.value === userInfo?.userid)?.name}
                      </p>
                    </div>
                  );
                } else {
                  if (item.key === "appSheetCnt") {
                    return (
                      <div key={item.key}>
                        {needSheetCnt && (
                          <div
                            key={item.key}
                            className={innerStyles[`${item.key}`]}>
                            <InputsCreatorUniversal
                              option={item}
                              styles={styles}
                              register={register}
                              newData={newData}
                              control={control}
                              setValue={setValue}
                              mode={mode}
                              errors={errors}
                              clearErrors={clearErrors}
                            />
                          </div>
                        )}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        key={item.key}
                        className={innerStyles[`${item.key}`]}>
                        <InputsCreatorUniversal
                          option={item}
                          styles={styles}
                          register={register}
                          newData={newData}
                          control={control}
                          setValue={setValue}
                          getValues={getValues}
                          mode={mode}
                          errors={errors}
                          clearErrors={clearErrors}
                        />
                      </div>
                    );
                  }
                }
            }
          })}
        </>
      ) : (
        <div className={innerStyles["content-container"]}>
          <div className={innerStyles["inputs-container"]}>
            {Object.values(optionsAppFooterRHF.inputsOptions).map((item) => {
              switch (item.type) {
                case "file":
                  return (
                    newData.viewFileName && (
                      <div
                        key={item.key}
                        className={innerStyles["text-block-view"]}>
                        <p className={innerStyles["option-label-view"]}>Файл заявления</p>
                        <a
                          className={innerStyles["option-value-view"]}
                          href={`${fileDownloadApi}${newData.appFileId}`}
                          target="_blank">
                          {newData.viewFileName}
                        </a>
                      </div>
                    )
                  );
                default:
                  if (item.key === "appUser") {
                    return (
                      <div
                        key={item.key}
                        className={`${innerStyles["text-block-view"]} ${innerStyles["appuser-block"]}`}>
                        <p className={innerStyles["option-label-view"]}>{item.label}</p>
                        <p className={innerStyles["option-value-view"]}>
                          {usersLibrary.find(
                            (elem) => elem.value === newData?.inspector || elem.value === newData?.appUser,
                          )?.name || usersLibrary.find((elem) => elem.value === userInfo?.userid)?.name}
                        </p>
                      </div>
                    );
                  } else {
                    return (
                      newData[item.key] && (
                        <div
                          key={item.key}
                          className={innerStyles["text-block-view"]}>
                          <p className={innerStyles["option-label-view"]}>{item.label}</p>
                          <p className={innerStyles["option-value-view"]}>
                            {item.type === "date" && newData?.[item.key]
                              ? newData?.[item.key].split("-").reverse().join(".")
                              : newData?.[item.key] || "—"}
                          </p>
                        </div>
                      )
                    );
                  }
              }
            })}
          </div>
        </div>
      )}
    </div>
  );
}
